import { ListTypeSelect } from '@aibees/elephant/components/list-type-select';
import { SearchBarFilter } from '@aibees/elephant/components/search-bar-filter';
import { TableLabelType } from '@aibees/elephant/components/table-label-type';
import { LabelName } from '@aibees/elephant/feature/label-management-table/components/label-name';
import { useBrowseLabel } from '@aibees/elephant/hooks/labels/use-browse-label';
import { Label, LabelGrouping, LabelType } from '@aibees/elephant/types/label';
import {
  DateTime,
  TableCellTypography,
  TextEllipsis,
} from '@aibees/shared/components';
import { AdvanceTableConfig } from '@aibees/shared/features';
import {
  DATE_FORMAT_YYYY_MM_DD_hh_mm_a,
  fHumanReadableNumber,
  userGetShortName,
} from '@aibees/shared/utils';
import { CardBodyTotalRecords } from '../../styles';
import { LabelSearchTableAction } from './actions/label-search-table-action';
import * as SX from './sx';

export const config: AdvanceTableConfig<Label> = {
  columns: [
    {
      id: 'name',
      label: 'Name',
      sortable: 'name',
      width: 132,
      render: (_, v) => <LabelName item={v} />,
      align: 'left',
    },
    {
      id: 'type',
      label: 'Type',
      sortable: 'grouping',
      width: 96,
      render: (_, v) => (
        <TableLabelType isCompany={v.grouping === LabelGrouping.COMPANY} />
      ),
    },
    {
      id: 'records',
      label: 'Total',
      sortable: true,
      width: 80,
      render: (v) => (
        <CardBodyTotalRecords>{fHumanReadableNumber(v)}</CardBodyTotalRecords>
      ),
    },
    {
      id: 'workspace',
      label: 'Team',
      sortable: true,
      width: 96,
      render: (_, v) => (
        <TextEllipsis>
          <TableCellTypography item={userGetShortName(v.workspace.user)} />
        </TextEllipsis>
      ),
    },
    {
      id: 'modified',
      label: 'Last Modified',
      sortable: true,
      width: 140,
      render: (v, d) => (
        <DateTime
          value={v ?? d.modified}
          format={DATE_FORMAT_YYYY_MM_DD_hh_mm_a}
        />
      ),
    },
  ],
  actions: [LabelSearchTableAction],
  browseApi: useBrowseLabel,
  extraFilters: { type: LabelType.LABEL },
  filters: [SearchBarFilter, ListTypeSelect],
  actionsConfig: {
    label: 'Action',
    minWidth: '10%',
    align: 'center',
    sx: { display: 'flex', justifyContent: 'center' },
  },
  stickyHeader: true,
  hideColumnsOnNoData: true,
  showTablePrependOnNotFound: true,
  defaultOrderBy: 'modified',
  emptyProps: {
    emptyIcon: 'label',
    emptyIconWrapperSX: SX.emptyIconWrapper,
    titleSx: { fontSize: 14 },
    iconSize: 28,
  },
  hideResetFilters: true,
  cellSx: { px: 0.5, py: 1 },
  bordered: 'solid',
  rowsPerPageOptions: [5],
  showJumpToPage: false,
  showPageSelector: false,
  filtersSx: { flexDirection: 'row !important' },
};
